import { render, staticRenderFns } from "./OrderService.vue?vue&type=template&id=85ba3950&scoped=true&"
import script from "./OrderService.vue?vue&type=script&lang=js&"
export * from "./OrderService.vue?vue&type=script&lang=js&"
import style0 from "./OrderService.vue?vue&type=style&index=0&id=85ba3950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba3950",
  null
  
)

export default component.exports